// extracted by mini-css-extract-plugin
export default {"cls1":"PaperLinkElement-cls1_Di8","cls2":"PaperLinkElement-cls2_LuF PaperLinkElement-cls1_Di8"};